<!-- Dialog di conferma duplicato contact -->
<h1 mat-dialog-title>{{ 'contact.duplicateConfirmation.title' | translate }}</h1>

<div mat-dialog-content>
  <!-- Messaggio di avviso con icona più evidente -->
  <div class="warning-message">
    <mat-icon color="warn">warning</mat-icon>
    <span>{{ 'contact.duplicateConfirmation.message' | translate }}</span>
  </div>
  
  <!-- Messaggio dettagliato -->
  <p class="confirmation-message">
    {{ 'contact.duplicateConfirmation.question' | translate }}
  </p>
</div>

<!-- Pulsanti di azione ben separati -->
<div mat-dialog-actions>
  <ct-button [configuration]="cancelButton"></ct-button>
  <ct-button [configuration]="confirmButton"></ct-button>
</div>
